<template>
  <div>
    <!-- table -->
    <b-card>
      <!-- if data not empty -->
      <div v-if="attendences.length !== 0">
        <b-table
          responsive="sm"
          :items="attendences"
          :fields="fields"
        />
      </div>

      <!-- if data empty -->
      <div
        v-else
        class="text-center"
      >
        <span class="font-weight-bold">No Result</span>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BModal,
  BCard,
  BTable,
  BBadge,
  BButton,
  BCol,
  BRow,
  BCardText,
  BAvatar,
  BLink,
  BContainer,
  BFormSelect,
} from 'bootstrap-vue'

export default {
  name: 'AttendencesTable',
  components: {
    BCard,
    BModal,
    BButton,
    BCol,
    BBadge,
    BAvatar,
    BTable,
    BRow,
    BContainer,
    BCardText,
    BLink,
    BFormSelect,
  },
  props: {
    attendences: Array,
  },
  data() {
    return {
      show: false,
      selectedItem: {},
      fields: [
        {
          key: 'attended_date',
          label: 'Attended Date',
          sortable: true,
        },
      ],
    }
  },
}
</script>

<style>
.custom-cell-padding {
  height: 70px; /* Set your desired padding value */
}
</style>
